import { useRef, useState, useEffect } from "react";
import axios from "../api/axiosClient";
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import PageHeader from "../components/ui/PageHeader";
import CustomInput from "../components/ui/CustomInput";
import PageForm from "../components/ui/PageForm";
import CustomTablePagingInfo from "../components/ui/CustomTablePagingInfo";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CustomTable from "../components/ui/CustomTable";
import ActAsModal from "../components/Modals/ActAsModal";
import CustomGridCell from "../components/ui/CustomGridCell";

import { useSelector, useDispatch } from "react-redux";
import { setActAs } from "../redux/actasSlice";
import { Navigate, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { handleError, errorToast, useKeyDown } from "../services/serviceBase";
import { toast } from "react-hot-toast";
import * as apiService from "../services/apiService";

import { useLoading } from "../components/LoadingContext";

const ActAs = (props) => {
  const intl = useIntl();
  const { setLoading } = useLoading();

  const company = useSelector((state) => state.common.company);

  const [sapClientCode, setSapClientCode] = useState('');
  const [clientDescription, setClientDescription] = useState('');
  const [steathClientCode, setSteathClientCode] = useState('');
  const [vatNumber, setVatNumber] = useState('');
  const [jdaLocation, setJdaLocation] = useState('');
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState({ text: "", value: null });

  const [tableHeigth, setTableHeigth] = useState(260);
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 20;

  const dispatch = useDispatch();
  var navigate = useNavigate();

  const [openActAsModal, setOpenActAsModal] = useState({isOpen: false, customerCode: "", customerDescription: ""});
  const handleCloseActAsModal = () => setOpenActAsModal(false);

  const handleOpenActAsModal = (e, row) => {
      e.preventDefault();
      setOpenActAsModal({isOpen: true, customerCode: row.customerCode, customerDescription: row.customerDescription});
  };

  const withStealthFlow = useSelector((state) => state.common.withStealthFlow);

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var headerHeight = document.querySelector("#header").clientHeight;
    var pagingInfoHeight = document.querySelector("#pagingInfo").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight =
      pageHeight - fromHeight - headerHeight - pagingInfoHeight - 90;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useKeyDown(() => {
    handleSearch();
  }, ["Enter"]);

  useEffect(() => {
    getColumns();
  }, [rows, page, tableHeigth, company]);

  const handleActAs = (e, row) => {
    dispatch(
      setActAs({
        customerCode: row.customerCode,
        customerDescription: row.customerDescription,
        jdaLocationCode: row.jdaLocationCode,
        jdaLocationDescription: row.jdaLocationDescription
      })
    );
    navigate(`${process.env.PUBLIC_URL}/`);
  };

  const handleActAsWithJdaLocation = (e, row) => {
    setLoading(true);
    const params = new URLSearchParams([]);

    params.append("idCompany", company);
    params.append("jdaLocation", `${row.jdaLocationCode}`);

    axios
      .get("/masterdata/Shops", { params })
      .then((response) => {
        setLoading(false);
        dispatch(
          setActAs({
            customerCode: row.customerCode,
            customerDescription: row.customerDescription,
            jdaLocationCode: response.data.jdaLocation,
            jdaLocationDescription: response.data.jdaLocationDescription,
            shopCode: response.data.shopCode,
            shopDescription: response.data.shopDescription,
          })
        );
        navigate(`${process.env.PUBLIC_URL}/`);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getColumns = () => {
    let columnColor = withStealthFlow ? "#7f7f7f" : "white"
    setColumns([
      {
        field: "actions",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        flex: 1,
        minWidth: 50,
        maxWidth: 80,
        renderCell: (params) => {
          if(params.row.jdaLocationCode !== null && params.row.jdaLocationCode !== '' && params.row.jdaLocationCode != undefined)
          {
            return (
              <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(event) => handleActAsWithJdaLocation(event, params.row)}
            >
              <ArrowForwardIosIcon />
            </IconButton>
            );
          }
          else if(withStealthFlow){
            return (
              <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(event) => handleOpenActAsModal(event, params.row)}
            >
              <ArrowForwardIosIcon />
            </IconButton>
            );
          }
          else{
            return (
              <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(event) => handleActAs(event, params.row)}
            >
              <ArrowForwardIosIcon />
            </IconButton>
            );
          }
        },
      },
      {
        field: "customerCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: columnColor }}>
            {intl.formatMessage({ id: "ActAs.SapClient" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.customerCode}
              width="100%"
              heigth="100%"
              display={withStealthFlow ? "none" : "flex"}
              alignItems="center"
              color="black"
            />
          );
        },
      },
      {
        field: "stealthCustomerCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "ActAs.StealthClient" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 200,
      },
      {
        field: "customerDescription",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "ActAs.SapSender" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150
      },
      {
        field: "jdaLocationCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "ActAs.JDALocationCode" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 160,
      },
      {
        field: "country",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Country" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 120,
      },      
      {
        field: "city",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.City" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 120,
      },
      {
        field: "zipCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.ZipCode" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 120,
      },
      {
        field: "address",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Address" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 200,
      }
    ]);
  };

  const handleSearch = () => {
    setLoading(true);
    const params = new URLSearchParams([]);

    if (company !== undefined && company !== "") {
      params.append("IdCompany", `${company}`);
    }
    if (
      sapClientCode !== undefined &&
      sapClientCode !== ""
    ) {
      params.append("CustomerCode", `${sapClientCode}`);
    }
    if (
      clientDescription !== undefined &&
      clientDescription !== ""
    ) {
      params.append("CustomerDescr", `${clientDescription}`);
    }
    if (
      steathClientCode !== undefined &&
      steathClientCode !== ""
    ) {
      params.append("STEALTHCustomerCode", `${steathClientCode}`);
    }

    if (country != null && country.text !== undefined && country.text !== "") {
      params.append("IdCountry", `${country.value}`);
    }

    if (
      vatNumber !== undefined &&
      vatNumber !== ""
    ) {
      params.append("VatNumber", `${vatNumber}`);
    }

    if (
        jdaLocation !== undefined &&
        jdaLocation !== ""
      ) {
        params.append("JDALocation", `${jdaLocation}`);
      }

    if (page.current === 0) {
      page.current = 1;
    }
    params.append("PagingInfo.Skip", `${rowsForPage * (page.current - 1)}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);

    axios
      .get("/customers/search", { params })
      .then((response) => {
        setLoading(false);
        setRows(response.data.paginatedItems);
        resizeTable();
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleReset = () => {
    setSapClientCode('');
    setClientDescription('');
    setSteathClientCode('');
    setCountry({ text: "", value: null });
    setVatNumber('');
    setJdaLocation('');
  };

  const handleNone = () => {
    dispatch(setActAs({ customerCode: null }));
    navigate(`${process.env.PUBLIC_URL}/`);
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearch();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 1) {
      page.current = page.current - 1;
      handleSearch();
    }
  };

  const getCountries = async () => {
      setLoading(true);
      apiService.getCountries(
        (response) => {
          setLoading(false);
          var countrySelectItems = [];
          if (response !== undefined) {
            response.map((x) => {
              countrySelectItems.push({
                value: x.idCountry,
                text: x.countryDescription,
              });
            });
          }
          setCountries(countrySelectItems);
        },
        (error) => {
          setLoading(false);
          handleError(error, intl);
        }
      );
    };

  useState(() => {
    getCountries();
  }, []);

  const handletrasitionEnd = () => {
    resizeTable();
  };

  return (
    <Box>
      <PageHeader title={intl.formatMessage({ id: "ActAs.Title" })} />
      <PageForm
        adjustHeightFunc={handletrasitionEnd}
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <Box>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "ActAs.JDA" })}
                    type="text"
                    value={jdaLocation}
                    setValue={setJdaLocation}
                    textCol={3}
                    inputCol={9}
                  />
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Box>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "ActAs.VATNumber" })}
                    type="text"
                    value={vatNumber}
                    setValue={setVatNumber}
                    textCol={3}
                    inputCol={9}
                  />
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Box>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "General.SapClientCode",
                    })}
                    type="text"
                    value={sapClientCode}
                    setValue={setSapClientCode}
                    textCol={3}
                    inputCol={9}
                    classLabel={withStealthFlow ? "apeDisabledColor" : ""}
                    disabled={withStealthFlow}
                  />
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Box>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "General.ClientDescription",
                    })}
                    type="text"
                    value={clientDescription}
                    setValue={setClientDescription}
                    textCol={3}
                    inputCol={9}
                  />
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Box>
                  <CustomInput
                    labelText={intl.formatMessage({
                      id: "General.StealthClientCode",
                    })}
                    type="text"
                    value={steathClientCode}
                    setValue={setSteathClientCode}
                    textCol={3}
                    inputCol={9}
                  />
                </Box>
              </Grid>
              <Grid item sm={6}>
                <Box>
                  <CustomInput
                    labelText={intl.formatMessage({ id: "General.Country" })}
                    type="autocomplete"
                    value={country}
                    selectItems={countries}
                    setValue={setCountry}
                    textCol={3}
                    inputCol={9}
                  />
                </Box>
              </Grid>
              <Grid item sm={2}>
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleNone}
                >
                  {intl.formatMessage({ id: "ActAs.None" })}
                </Button>
              </Grid>
              <Grid item sm={6}></Grid>
              <Grid item sm={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleReset}
                >
                  {intl.formatMessage({ id: "General.Reset" })}
                </Button>
              </Grid>
              <Grid item sm={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleSearch}
                >
                  {intl.formatMessage({ id: "General.Search" })}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <CustomTablePagingInfo
        totalCount={totalCount}
        page={page.current}
        maxPage={maxPage.current}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
      />
      <CustomTable
        columns={columns}
        rows={rows}
        id={"customerCode"}
        rowHeight={70}
        headerHeight={50}
        tableHeight={tableHeigth}
      />
      
      <ActAsModal
        openModal={openActAsModal.isOpen}
        handleCloseModal={handleCloseActAsModal}
        customerCode={openActAsModal.customerCode}
        customerDescription={openActAsModal.customerDescription}
        withStealthFlow={withStealthFlow}
      />
    </Box>
  );
};

export default ActAs;
